import './LocalLogin.scss';
import { InputText } from 'primereact/inputtext';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { setToken } from '../../features/authSlice';
import { Language } from '../language/Language';
import { useTranslation } from "react-i18next";
import axios, { AxiosError } from 'axios';
import { useAppSelector } from '../../store/hooks';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { setUser, setUserGroup, setUserGroups } from '../../features/sharedSlice';
export interface Customize {
    id: number;
    logo: string;
    primarycolor: string;
    secondarycolor: string;
    startextent: string | null,
}

export const LocalLogin = () => {
    const toast = useRef<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [customize, setCustomize] = useState<Customize>();
    const [checkboxStatus, setCheckboxStatus] = useState<boolean>(false);
    const activeLanguage = useAppSelector(state => state.language.activeLanguage);
    const [dialogVisibility, setDialogVisibility] = useState(false)
    const userGroups: any = useAppSelector(state => state.sharedState.userGroups);
    const selectedUserGroup: any = useAppSelector(state => state.sharedState.userGroup);
    const user: any = useAppSelector(state => state.sharedState.user);

    useEffect(() => {
        getCustomize();
        rememberMe();
    }, [])

    useEffect(() => {
        localStorage.setItem('activeLanguage', activeLanguage ? activeLanguage : 'tr');
    }, [activeLanguage])

    const getCustomize = () => {
        axios.get(process.env.REACT_APP_BASE_URL + 'rest/v1/customize').then((res) => {
            setCustomize(res.data.customize)
        })
    }
    //remember me seçili ise username ve passwordu saklar 
    const rememberMe = () => {
        const username = localStorage.getItem('username')
        if (username) {
            setUsername(username)
        }
    }

    const getUserGroups = async (userId: number) => {
        const response: any = await axios.get(process.env.REACT_APP_BASE_URL + 'rest/v1/user/' + userId + '/groups', { params: { token: getToken() } });
        const userGroups = response.data.groups;
        dispatch(setUserGroups(userGroups));
        if (userGroups.length > 1) {
            setDialogVisibility(true)
        }
        else {
            //tek user group varsa
            dispatch(setUserGroup(userGroups[0]))
            filterPermsByUserGroup(userGroups[0])
        }
    }

    const filterPermsByUserGroup = async (userGroup?: any) => {
        localStorage.setItem('selectedUserGroupId', userGroup.id)
        const body = {
            username: user.username,
            groupId: userGroup.id
        }
        const response = await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/user/groupToken?token=${getToken()}`, body)
        localStorage.setItem('token', response.data.token_with_group_id)
        dispatch(setToken(response.data.token_with_group_id))
        navigate("/");
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        axios.post(process.env.REACT_APP_BASE_URL + 'rest/v1/auth/login', { username, password }).then((res) => {
            if (res.data.token) {
                localStorage.setItem('token', res.data.token)
                getUser()
                // getUserGroups()
                if (checkboxStatus) {
                    localStorage.setItem('username', username)
                }
                else {
                    localStorage.removeItem('username')
                }
                // navigate("/");
                dispatch(setToken(res.data.token))
            }
        }).catch((err: AxiosError) => {
            if (err.response?.status === 401) {
                toast.current?.show({ severity: 'error', detail: (t('LOGIN.Login Fail')), life: 3000 });
                navigate("/login/index");
            }
            else {
                toast.current?.show({ severity: 'error', detail: `${t("MESSAGE.AxiosAutoError")} ${err.response?.status ? err.response?.status : ''}`, life: 3000 });
                navigate("/login/index");
            }
            // if (err.response?.status === 400) {
            //     localStorage.removeItem('token')
            // }
        })
    }

    const getUser = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_BASE_URL + `rest/v1/user/me?token=${getToken()}`)
            if (response) {
                dispatch(setUser(response.data.user));
                // if (!response.data.user.isactive) {
                //     alert('Kullanıcı aktif değil')
                //     dispatch(setToken(undefined))
                //     // logout();
                // }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        if (user && user.id && getToken()) {
            getUserGroups(user.id)
        }
    }, [user])


    const getToken = () => {
        return localStorage.getItem('token');
    };

    const onHide = () => {
        setDialogVisibility(false)
    }

    return (
        <div className='login-page'>
            <div className='language-selection'>
                <Language />
            </div>
            < div className='login' >
                <form onSubmit={handleSubmit}>
                    <div className='content'>
                        <div className='header'>
                            <img draggable='false' src='sb-logo.png' alt='logo' width='150px' />
                            <p className='logo-text'>T.C. SANAYİ VE<br></br> TEKNOLOJİ BAKANLIĞI</p>

                        </div>
                        <div className='login-container'>
                            <p className='title'>MEKANSAL YÖNETİM ve <br /><span>DİJİTALLEŞTİRME PROJESİ</span></p>

                            <div className='input-group'>
                                <div className='p-field'>
                                    <label className='p-d-block'>{t('LOGIN.Username')}</label>
                                    <InputText value={username} onChange={(e) => setUsername(e.target.value)} />
                                </div>
                                <div className='p-field'>
                                    <label className='p-d-block'>{t('LOGIN.Password')}</label>
                                    <Password type='password' value={password} onChange={(e) => setPassword(e.target.value)} toggleMask feedback={false} />
                                </div>
                            </div>
                            <div className='group'>
                                <div className='p-col-12'>
                                    <Checkbox inputId='remember-me' onChange={e => setCheckboxStatus(e.checked)} checked={checkboxStatus}></Checkbox>
                                    <label htmlFor='remember-me' style={{ marginLeft: '3px', cursor: 'pointer' }} className='p-checkbox-label'>{t('LOGIN.Remember Me')}</label>
                                </div>
                            </div>
                            <div className='login-buttons2'>
                                <Button className='but' type='submit' label={t('BUTTON.Login')} />
                                {/* <a href='https://sso.sanayi.gov.tr/serviceredirector.aspx?sid=62c2d7b9-2c64-4876-9708-72b419f3e316'>
                                    <Image src='edevlet.png' alt='edevlet' width='190em' />
                                </a> */}
                            </div>
                        </div>
                    </div>
                </form>
                <div style={{ width: '100%', height: '100%' }}>
                    {dialogVisibility && <Dialog header={'Kullanıcı Grubu Belirlerme'} className="custom-popup" visible={true}
                        onHide={onHide} closable={false}
                    >{
                            <div>
                                <p>Devam etmek istediğiniz kullanıcı grubunu seçiniz.</p>
                                <Dropdown className='role-dropdown' filter value={selectedUserGroup} options={userGroups} optionLabel='name' onChange={(e: any) => dispatch(setUserGroup(e.target.value))} placeholder='Sanayi alanını seçiniz' style={{ height: '36px', display: 'flex', alignItems: 'center' }} />
                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                                    <Button label='Kaydet' onClick={() => filterPermsByUserGroup(selectedUserGroup)}></Button>
                                </div>
                            </div>

                        }
                    </Dialog>}

                </div>
                <Toast ref={toast} position='bottom-center' className='login-toast' style={{ zIndex: '9 !important' }} />
            </div >
        </div>
    )
}